export default function IconRoundChevronLeft({ className }: { className?: string }) {
    return (
        <svg
            className={className}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="-0.5"
                y="0.5"
                width="19"
                height="19"
                rx="9.5"
                transform="matrix(-1 0 0 1 19 0)"
                stroke="#CDCDCD"
            />
            <path
                d="M7.375 10L11.125 6.25L11.65 6.775L8.425 10L11.65 13.225L11.125 13.75L7.375 10Z"
                fill="#767676"
            />
        </svg>
    )
}
